import {
  Container,
  Divider,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  Card,
  CardContent,
  IconButton,
} from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

function CreateWaiterDialog({
  visible,
  onSubmit,
  onClose,
  initialValue,
  title,
  okText,
  outlet
}) {

  if (initialValue == undefined)
    initialValue = {
      name: initialValue.name == undefined ? '' : initialValue.name,
      commission: initialValue.commission == undefined ? '' : initialValue.commission,
    }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
    commission: Yup.number()
      .typeError('Invalid Number')
      .min(0, 'Percentage must be between 0 and 100')
      .max(100, 'Percentage must be between 0 and 100'),
  })

  const handleSubmit = (values) => {
    onSubmit(values)
  }

  return (
    <div>
      <Dialog
        maxWidth="xs"
        fullWidth
        open={visible}
      >
        <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
          {title}
          <IconButton
            component="span"
            size='small'
            sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
            onClick={onClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <Container sx={{ marginBottom: 5 }} >
          <Formik
            initialValues={initialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              touched,
              values,
              status,
            }) => (
              <form onSubmit={handleSubmit}>
                <Divider />
                <Card>
                  <CardContent>
                    <Grid container spacing={3} pt={1}>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="name"
                          label="Name"
                          value={values.name}
                          error={Boolean(touched.name && errors.name)}
                          fullWidth
                          helperText={touched.name && errors.name}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="outlet"
                          label="Outlet"
                          value={outlet}
                          error={Boolean(touched.outlet && errors.outlet)}
                          fullWidth
                          helperText={touched.outlet && errors.outlet}
                          onBlur={handleBlur}
                          margin="dense"
                          variant="outlined"
                          disabled
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3} pt={2}>
                      <Grid item md={6}>
                        <TextField
                          size='small'
                          name="commission"
                          label="Commission (%)"
                          value={values.commission ?? ""}
                          error={Boolean(touched.commission && errors.commission)}
                          fullWidth
                          helperText={touched.commission && errors.commission}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={(e) => {
                            const v = e.target.value;
                            if (v === "") {
                              setFieldValue("commission", "");
                              return;
                            }
                            // Live filter: digits, at most one dot, max 2 decimals, range 0-100
                            if (!/^\d*\.?\d{0,2}$/.test(v)) return;
                            if (Number(v) > 100) return;
                            setFieldValue("commission", v);
                          }}
                          inputProps={{ inputMode: "decimal", maxLength: 6 }}
                          type="text"
                          variant="outlined"
                          my={2}
                        />

                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Dialog>
    </div>
  )
}

export default CreateWaiterDialog
